import isDevMode from "../environment.function";
import { CurrentBidsDTO, MappedCurrentBid } from "./currentBids.type";
import { mapCurrentBids } from "./mapCurrentBids";

const fetchCurrentBids = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedCurrentBid[]> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isDevMode()) {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  const result: CurrentBidsDTO = await res.json();
  if (result.degradedServices?.length > 0) {
    throw new Error(`A service error occurred while fetching the data.`);
  }

  return mapCurrentBids(result);
};

export default fetchCurrentBids;
